import { FormattedMessage } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { AddCsvFile } from '../../../../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../../../../components/csv-import/ui/components/import-context';
import { ImportDescription } from '../../../../../../../../../components/csv-import/ui/components/import-description';
import { InitErrors } from '../../../../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepHeader } from '../../../../../../../../../components/csv-import/ui/components/step-header/step-header';
import { StepSuspense } from '../../../../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { WorkflowSteps } from '../../../../../../../../../tracking/use-workflow-tracking';
import { SET_IMPORT_OVERRIDE_CONFIG } from '../reducer';
import { messages } from './messages';
import styles from './styles.module.less';

const exampleFile = '/s3/marketplaces/shipstation/AsnCsvImportTemplate.csv';

export const ConfigStepBody = () => {
  const { isGetMappingsLoading, isInitImportLoading, form, trackProcess, dispatch } = useImportContext();

  const handleCheckboxChange = (isChecked) => {
    dispatch({ type: SET_IMPORT_OVERRIDE_CONFIG, overrideConfig: isChecked });

    trackProcess(WorkflowSteps.CSV_IMPORT_CHANGE_CUSTOM_PROPERTY, {
      overrideConfig: isChecked,
    });
  };

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.uploadFile} />
      </StepHeader>
      <ImportDescription file={exampleFile} message={messages.helpContentText} />
      <InitErrors />
      <AddCsvFile name='asn-import' />
      <FlexRow className={styles['dropdown-container']}>
        <FlexColumn className={styles['dropdown-wrapper']} gap={Gap.Space4}>
          <Text className={styles['dropdown-title']} textType={TextType.H4} value={messages.importBehaviorHeader} />
          <Checkbox
            checked={form.overrideConfig}
            label={<FormattedMessage {...messages.importBehaviorCheckbox} />}
            largeCheckbox
            onChange={handleCheckboxChange}
          />
        </FlexColumn>
        <FlexColumn className={styles['dropdown-wrapper']}>
          <MappingList menuClassName={styles['dropdown-menu']} />
        </FlexColumn>
      </FlexRow>
    </StepSuspense>
  );
};
